import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function multiplexerAlreadyHeldBuilder() {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        A trade plan was not able to enter because it was blocked from entering
        by another trade plan.
      </Body3>
    </td>
  );
}
